import Vue from "vue"

import Router from "vue-router"
Vue.use(Router)

const routes = [
  {
    path: "/",
    component: () => import("@/page/indexPage"),
  },
  {
    path: "/systemShow",
    component: () => import("@/page/systemShowPage"),
  },
  {
    path: "/hgAlarm",
    component: () => import("@/page/hgAlarm"),
  },
]

const router = new Router({
  routes,
})

export default router
